module.exports = __webpack_public_path__ + "img/img_shou@2x.3af2a904.png";